import clsx from "clsx";

const IconRoundel = ({ icon, theme = "light" }) => {
  const Icon = icon;

  return (
    <div
      className={clsx(
        "flex h-10 w-10 items-center justify-center rounded-full",
        {
          "bg-white text-gray-900": theme === "light",
          "bg-gray-900 text-white": theme === "dark",
        },
      )}
    >
      <Icon className={clsx("h-5 w-5 stroke-[1.5]")} />
    </div>
  );
};

export default IconRoundel;
